'use client'

import Link from 'next/link'
import { ReactNode } from 'react'

interface TrackableLinkProps {
  href: string
  children: ReactNode
  className?: string
  category?: string
  label?: string
  target?: string
  rel?: string
  'aria-label'?: string
}

export function TrackableLink({
  href,
  children,
  className,
  category = 'Link Click',
  label,
  target,
  rel,
  'aria-label': ariaLabel,
}: TrackableLinkProps) {
  const handleClick = () => {
    // Push event to GTM dataLayer
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'link_click',
        link_category: category,
        link_label: label || href,
        link_url: href,
        link_target: target || '_self',
      })
    }
  }

  return (
    <Link
      href={href}
      className={className}
      onClick={handleClick}
      target={target}
      rel={rel}
      aria-label={ariaLabel}
    >
      {children}
    </Link>
  )
}

// Button tracking helper
export function trackButtonClick(buttonName: string, category = 'Button Click') {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'button_click',
      button_category: category,
      button_name: buttonName,
    })
  }
}

// Form tracking helper
export function trackFormSubmit(formName: string, success: boolean) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'form_submit',
      form_name: formName,
      form_success: success,
    })
  }
}

// Custom event tracking helper
export function trackEvent(eventName: string, eventData: Record<string, any> = {}) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: eventName,
      ...eventData,
    })
  }
}
